import {regionState} from '../state/regionState';
import {Fetch_All_Region_Data, Update_Region_List_Success,
            Region_Data_Success,Fetch_Region_Request} from '../action/regionAction';

export function RegionReducer(state = regionState, action) {
    
    switch(action.type){
        case Fetch_All_Region_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                regionList : action.regionList
            })
        case Update_Region_List_Success:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                regionList : action.UpdatedList,
                message : action.message
            })
        case Region_Data_Success:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.Message,
                UpdatedList : action.list
            })
        case Fetch_Region_Request:
            return Object.assign({},state,{
                message : '',
                statusCode : 0
            })
        default:
            return state
    }
}